var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviouslastHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-nav-last",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1519",
    "data-name": "Rectangle 1519",
    width: 32,
    height: 32,
    rx: 4,
    fill: "#f6fafb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "last_page_FILL0_wght400_GRAD0_opsz48",
    d: "M12.525,23.875,11.45,22.8l4.8-4.8-4.8-4.8,1.075-1.075L18.4,18Zm9.7.125V12h1.5V24Z",
    transform: "translate(-1.45 -2)",
    fill: "#227c9d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviouslastHover);
export default __webpack_public_path__ + "static/media/PreviouslastHover.3c728295455a8e1de69c1374d8d7d67e.svg";
export { ForwardRef as ReactComponent };